module.exports = __webpack_public_path__ + "img/13.0c8c1c44.png";